<template>
  <section v-if="idSubscriber">
    <carousels-list
    :id-subscriber="idSubscriber" :all-channels="allChannels" />
  </section>
</template>

<script>
import CarouselsList from "./RestrictedChannelsList.vue";

export default {
  name: "RestrictedChannels",
  components: {CarouselsList},
  props:{
    subscriber: Object,
    allChannels: Array,
  },
  computed: {
    idSubscriber(){
      if(this.subscriber && 'id' in this.subscriber){
        return this.subscriber.id;
      }else{
        return null;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/restrictedChannels/RestrictedChannels.vue